/**
 * How many dice a click on the dice bar rolls. Maz, 2026-10-21: more than one die at a time ("rolled 3d6: 4 + 2 + 6
 * = 12" on one line, not three lines). The server accepts up to 100; the box stops at a number a person would
 * actually roll, and anything unreadable is one die rather than an error.
 */

export const MAX_DICE_BOX = 20;

/** The count a box's text means: a whole number from 1 to `MAX_DICE_BOX`, and 1 for anything else. */
export function diceCountFrom(text: string): number {
  const n = Number(text.trim());
  if (!Number.isInteger(n) || n < 1) return 1;
  return Math.min(n, MAX_DICE_BOX);
}

/** The label on a die's button: `d6`, or `3d6` once more than one will be rolled. */
export function dieLabel(count: number, sides: number): string {
  return `${count > 1 ? count : ''}d${sides}`;
}
